//eventually refactor /editor/[slug].js to use this component

import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import LinkIcon from '../../Icons/link';
import TwitterImage from '../../TwitterImage';
var twitter = require('twitter-text');

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

import { GlobeIcon } from '@heroicons/react/solid';
import { Tooltip } from 'react-tippy';

export default function LinkedinPostPreview({
  hasCustomLinkedinText,
  setLinkedinTextReady,
  linkedinEditorText,
  hasLinkedin,
  passLinkedinText,
  linkedinProfile,
  inEditor = false,
  twitterType = 'image',
  saveCustomLinkedinText,
  removeCustomLinkedinText,
}) {
  const [linkedinText, setLinkedinText] = useState('');
  const [autoFormatUsed, setAutoFormatUsed] = useState(false);

  useEffect(() => {
    if (linkedinEditorText) {
      getInitialLinkedinText(linkedinEditorText);
    }
  }, [linkedinEditorText]);

  const getInitialLinkedinText = (text, autoFormat = false) => {
    setLinkedinTextReady(false);

    var hasIMGS = false;

    if (text.includes('<img')) {
      hasIMGS = true;
    }
    /*         setHasImages(hasIMGS)
     */

    //replcae with 2 new lines to make it look nicer - at the cost of not exact match to the original text

    //TODO: for auto format to work, you need to also pass a modified HTMl version to the saveCustomLinkedinText function (if you want to save it to the db so it can be used later in the editor)

    var convertedText = autoFormat
      ? text.replace(
          /<\/(h2|h3|p|blockquote|img|code)><(h2|h3|p|blockquote|img|code)>/g,
          '\n\n',
        )
      : text.replace(
          /<\/(h2|h3|p|blockquote|img|code)><(h2|h3|p|blockquote|img|code)>/g,
          '\n',
        );

    //if autoFormat is true, find all /n• and replace with •

    var convertedText = convertedText.replace(
      /<ul>/g,
      autoFormat ? '\n\n' : '\n',
    );
    var convertedText = convertedText.replace(
      /<ol>/g,
      autoFormat ? '\n\n' : '\n',
    );
    var convertedText = autoFormat
      ? convertedText.replace(/<\/(ol|ul)>/g, '\n')
      : convertedText;
    var convertedText = convertedText.replace(
      /<\/li>/g,
      autoFormat ? '\n' : '\n',
    );
    convertedText = convertedText.replace(/(<li>)/g, '• ');
    convertedText = convertedText.replace(
      /(<br>)/g,
      autoFormat ? '\n\n' : '\n',
    );
    convertedText = convertedText.replace(
      /(<a target="_blank" rel="noopener noreferrer nofollow" href=")(.*)(">)(.*)(<\/a>)/g,
      '$2',
    );

    var linkedinPlainText = convertedText.replace(/<[^>]*>?/gm, '');
    linkedinPlainText = linkedinPlainText.trim();
    var lText = convertToPlainText(linkedinPlainText);

    autoFormat ? setAutoFormatUsed(true) : setAutoFormatUsed(false);

    //TODO: save html format per above comment
    // autoFormat ? saveCustomLinkedinText(lText) : null;

    setLinkedinText(lText);
    passLinkedinText(lText);
  };

  const convertToPlainText = (html) => {
    var el = document.createElement('div');
    el.innerHTML = html;
    var text = el.textContent;
    return text;
  };

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const autoFormat = (undo = false) => {
    getInitialLinkedinText(linkedinEditorText, undo ? false : true);
    if (undo) {
      //remove custom text from DB
      removeCustomLinkedinText();
    }
    //need to save this new text as custom linkeidn text
  };

  return (
    <>
      <div className="relative flex w-full max-w-lg flex-grow flex-col space-y-4 bg-white">
        <div className="flex w-full flex-row items-center justify-between">
          <div className="flex flex-row items-center justify-start space-x-2">
            <img
              src={
                linkedinProfile ? linkedinProfile.image : '/default-avatar.png'
              }
              className={'rounded-full'}
              width={32}
              height={32}
            />
            <div className="flex flex-col items-start justify-start space-y-0">
              <p className="text-sm font-semibold text-gray-900">
                {linkedinProfile.name} {linkedinProfile.surname}
              </p>
              <div className="flex flex-row items-center justify-start space-x-1">
                <p className="text-xs text-gray-500">Now</p>
                <div className="h-[3px] w-[3px] rounded-full bg-gray-500" />
                <GlobeIcon className="h-4 w-4 text-gray-500" />
              </div>
            </div>
          </div>

          {twitterType === 'image' && !hasCustomLinkedinText ? (
            <Tooltip
              html={
                <div className="flex flex-col items-start justify-start text-sm font-semibold antialiased">
                  <p className="text-xs text-white">
                    {autoFormatUsed
                      ? 'Undo Magic Linkedin formatting'
                      : 'Automatically format your post to look great on Linkedin 🪄'}
                  </p>
                </div>
              }
              position="top"
              interactive={false}
              animateFill={false}
              theme="dark"
              arrow={true}
              arrowSize="small"
              trigger="mouseenter"
              offset={1}
              disabled={false}
            >
              <button
                onClick={() => autoFormat(autoFormatUsed)}
                className=" flex flex-row rounded-full bg-blue-500/10 px-2 py-1 text-xs font-medium text-blue-500 duration-150 hover:bg-blue-500/20 hover:text-blue-600 active:scale-95"
              >
                {autoFormatUsed ? 'Undo Magic Format' : '🪄 Magic Format'}
              </button>
            </Tooltip>
          ) : null}
        </div>

        {linkedinText ? (
          <p className="resize-none truncate whitespace-pre-wrap border-none border-transparent p-0 font-sans text-sm text-gray-900 outline-none focus:border-none focus:border-transparent focus:outline-none focus:ring-0">
            {linkedinText}
          </p>
        ) : (
          <p className="font-sans text-sm text-gray-500">
            Text for LinkedIn will show up here...
          </p>
        )}

        {linkedinText && (
          <div className="flex w-full justify-end py-0">
            <p
              className={`${
                linkedinText.length > 2900
                  ? 'font-semibold text-red-500'
                  : 'font-medium text-gray-500 '
              } font-sans text-xs`}
            >
              {numberWithCommas(linkedinText.length)}/2,900
            </p>
          </div>
        )}
      </div>
    </>
  );
}
